import React from 'react';
import { Field } from 'react-final-form';
import type { FieldProps, FieldRenderProps } from 'react-final-form';
import type { FieldValidator } from 'final-form';
import DatePickerInputV2 from '../DatePickerInputV2/DatePickerInputV2';
import type { DatePickerInputV2Props } from '../DatePickerInputV2/DatePickerInputV2';
import transformValidateProp from '../../util/transformValidateProp';

export interface FormDatePickerProps<
  RP extends FieldRenderProps<string, T>,
  T extends HTMLElement = HTMLElement
> extends Omit<FieldProps<string, RP, T>, 'validate'>,
    DatePickerInputV2Props {
  name: string;
  validate?: FieldValidator<string>[] | FieldValidator<string> | null;
}

const FinalFormDatePickerV2 = <
  RP extends FieldRenderProps<string, T>,
  T extends HTMLElement = HTMLElement
>({
  name,
  validate,
  ...rest
}: FormDatePickerProps<RP, T>): React.ReactElement => {
  const composedValidators = transformValidateProp(validate);

  return (
    <Field name={name} validate={composedValidators} {...rest}>
      {({
        formatDate,
        parseDate,
        isRequired,
        label,
        placeholder = 'MM/DD/YYYY',
        input,
        meta,
        id,
        ...rest
      }) => {
        const errorMessage = meta && meta.touched && meta.error ? meta.error : '';
        const newInputProps = { ...input, errorMessage, placeholder, isRequired, label, id };
        return (
          <DatePickerInputV2
            inputFieldProps={newInputProps}
            value={input?.value}
            formatDate={formatDate}
            parseDate={parseDate}
            isFormField
            {...rest}
          />
        );
      }}
    </Field>
  );
};

export default FinalFormDatePickerV2;
